/**
 * Round 107 (2026-02-14) — asset_type → existing builder mapping.
 *
 * The strategist page (Content / Money / Business Builder) is a
 * REVIEW step, not a creation step. After the strategist presents
 * its recommendations, the customer clicks a primary "Create ..."
 * button that routes back to the dashboard and opens the
 * EXISTING specialized builder for that asset type.
 *
 * `action` matches the switch statement inside
 * `DashboardPage.handleWhatsNextAction(action)` so the existing
 * modal opens without changes to that dispatcher.
 */
export const ASSET_TYPE_TO_BUILDER = {
  content_pack:     { action: 'generate-content',   label: 'Create This Content' },
  weekly_content:   { action: 'generate-content',   label: 'Create This Content' },
  // Round 107.1 — defensive aliases: DailyMissionCard emits the
  // bot-internal focus in the URL `asset_type` param (e.g. 'post',
  // 'reel'). These aliases keep the primary CTA correct even if
  // the wctx doesn't carry a canonical asset_type.
  post:             { action: 'generate-content',   label: 'Create This Content' },
  reel:             { action: 'generate-content',   label: 'Create This Content' },
  lead_magnet:      { action: 'lead-magnet',        label: 'Create Lead Magnet' },
  email_sequence:   { action: 'email-sequence',     label: 'Create Email' },
  email:            { action: 'email-sequence',     label: 'Create Email' },
  sales_page:       { action: 'sales-page',         label: 'Create Sales Page' },
  offer_sheet:      { action: 'build-offer',        label: 'Create Offer' },
  offer:            { action: 'build-offer',        label: 'Create Offer' },
  business_profile: { action: 'business-essentials', label: 'Build Business Profile' },
  business_plan:    { action: 'monetization-plan',  label: 'Build Business Plan' },
};

export const getBuilderForAssetType = (assetType) => {
  if (!assetType) return null;
  return ASSET_TYPE_TO_BUILDER[assetType] || null;
};
